Librarian.Notification = new Class({
    Implements: [Options],
    Binds: ["close"],

    options: {
        message: "",
        type: null,
        closeAfter: false // Time in ms or false to leave open
    },

    messageEl: null,

    initialize: function(options) {
        this.setOptions(options);

        this.render();
    },

    render: function() {
        var message = this.options.message.replaceAll("\n", "<br>");

        this.messageEl = new Element("div", {
            html: message,
            "class": "notification-message"
        }).inject(Librarian.Notification.containerEl);

        if (this.options.type) {
            this.messageEl.addClass("notification-type-" + this.options.type);
        }

        this.messageEl.addOnClick(this.close);

        if (this.options.closeAfter > 0) {
            setTimeout(this.close, this.options.closeAfter);
        }
    },

    close: function() {
        this.messageEl.remove();
    }
});

Librarian.Notification.extend({
    containerEl: null,

    closeAll: function(type) {
        if (!this.containerEl)
            return;

        var selector = ".notification-message";
        if (type)
            selector += ".notification-type-" + type;

        var messageEls = this.containerEl.getElements(selector);

        messageEls.invoke("remove");
    }
});

window.addEvent("load", function() {
    Librarian.Notification.containerEl = new Element("div", {
        "class": "notification-container"
    }).inject(document.body);
});
